// extracted by mini-css-extract-plugin
export default {"loaderOverlay":"LoaderOvarlay_loaderOverlay__ynkC+","loaderGif":"LoaderOvarlay_loaderGif__CDDHl"};